/**
 * Demo-only constants. This is NOT a real secret: it signs synthetic fixtures
 * exchanged between the demo UI and its own Worker, never real third-party
 * webhooks or user data. It is intentionally public and documented in the README.
 */
export const DEMO_SIGNING_SECRET = 'wrp-demo-shared-secret-v1-public-non-sensitive';

export const RULES_VERSION = '1.0.0';
export const SCHEMA_VERSION = '1.0.0';

export const TIMESTAMP_TOLERANCE_SECONDS = 300;
export const IDEMPOTENCY_TTL_SECONDS = 60 * 60 * 24 * 7; // 7 days
export const SEQUENCE_TTL_SECONDS = 60 * 60 * 24 * 7;
export const RUN_TTL_SECONDS = 60 * 60 * 24 * 7;
export const MAX_RETRY_ATTEMPTS = 2;

export const MAX_FINDINGS = 1000;
